import React, { Component } from 'react';

import './custom-style.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { injectIntl } from "react-intl";
import { reduxForm } from 'redux-form'
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { FormLabel, Input } from '@material-ui/core';
import UserCreateApi from '../../api/Scoreboardapi';
import { Autocomplete } from '@material-ui/lab';
import clsx from "clsx";
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import SimpleReactValidator from 'simple-react-validator';
import Loader from 'react-loader-advanced';

import SweetAlert from 'react-bootstrap-sweetalert';
import { OverlayTrigger, Tooltip as BootstrapTooltip, Alert, Collapse, Fade } from "react-bootstrap";
import Modal from './Modal';
import Modal1 from "react-bootstrap/Modal";
import MenuLeftNav from './MenuLeftNav';
import { Helmet } from "react-helmet";
import { IsReferralAdmin } from "../../crud/auth.crud";

import axios from "axios";
import { emailFrequencyOptions } from "./emailFrequencyOptionsData";

const CancelToken = axios.CancelToken;
let cancel;
var isLoadFirstTime = 0;
var isChangedEvent = 0;
var papOptionsLoaded = false;
const renderField = ({
    input,
    label,
    type,
    disabled,
    isAsterisk,
    placeholder,
    meta: { touched, error }
}) => (
    <div className="formgroup row">
        <div className="col-lg-2 mt-3 text-right">
            {touched && error ? <div className="custom-label error-msg">{label}{isAsterisk && <sup style={{ color: "red" }}> *</sup>}</div> : <label htmlFor="title" className="custom-label">{label}</label>}
        </div>
        <div className="col-lg-6">
            <input {...input} type={type} className="form-control" name="title" placeholder={placeholder}></input>
            <div className="required-msg">{touched && error && <div className="error-msg">{error}</div>}</div>
        </div>
    </div>
)

const validate = values => {
    const errors = {}
    const requiredFields = [
        'name',
        'title',
        'role',
        'email',
        'organization',
        'referral',
    ]
    requiredFields.forEach(field => {

        if (!values[field] && field == 'name')
            errors[field] = 'Please enter name'
        else if (!values[field] && field == 'title')
            errors[field] = 'Please enter title'
        else if (!values[field] && field == 'role')
            errors[field] = 'Please enter role'
        else if (!values[field] && field == 'email')
            errors[field] = 'Please enter email'
        else if (!values[field] && field == 'organization') {
            if (!IsReferralAdmin()) {
                errors[field] = 'Please enter organization'
            }
        }
        else if (!values[field] && field == 'referral') {
            if (!IsReferralAdmin()) {
                errors[field] = 'Please enter referral'
            }
        }
        else if (!values[field]) {
            errors[field] = 'This field is required'
        }
    })
    if (
        values.email &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
        errors.email = 'Please enter valid email address'
    }
    if (values.phone && !/^\d{10}$/.test(values.phone)) {

        errors.phone = 'Phone number must contain 10 digit'
    }
    if (values.extension && !/^\d*[.]?\d*$/i.test(values.extension)) {
        errors.extension = 'Please enter only numeric value'
    }
    return errors
}

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


class Create extends Component {

    constructor(props) {
        super(props);
        let isLoading = false;
        if (this.props.match.params.userId) {
            isLoading = true;
        }
        this.state = {
            userList: [],
            name: '',
            title: '',
            role: { 'value': '', 'label': 'Pick a Role' },
            editPageRoleId: '',
            email: '',
            phone: '',
            extension: '',
            password: '',
            confirm_password: '',
            is_pap_account: { 'value': '', 'label': 'Is Pap Account?' },
            organization: [],
            referral: [],
            IsDeleteImage: false,
            isLoading: isLoading,
            submitBtnDisabled: false,
            avatar: '',
            roles: [],
            organizations: [],
            isPapAccountOption: [],
            isPapSelected: false,
            papType: '',
            airviewNameCheckbox: false,
            encoreNameCheckbox: false,
            airViewName: '',
            airviewOrganizationName: '',
            encoreName: '',
            encoreSleepLab: '',
            isErrorInAirView: false,
            isErrorInOrganizationName: false,
            isErrorInEncoreView: false,
            isErrorInEncoreSleepLab: false,
            isShowCareOrchestratorPhilipsInfo: false,
            currentPage: 1,
            isPapSelected: false,
            papType: '',
            airviewNameCheckbox: false,
            encoreNameCheckbox: false,
            airViewName: '',
            airviewOrganizationName: '',
            encoreName: '',
            encoreSleepLab: '',
            isErrorInAirView: false,
            isErrorInOrganizationName: false,
            isErrorInEncoreView: false,
            isErrorInEncoreSleepLab: false,
            isShowCareOrchestratorPhilipsInfo: false,
            currentSortOrder: "DESC",
            sortBy: "id",
            rowsPerPage: 5,
            totalRecords: 10,
            open: false,
            openIsPap: false,
            openOrganization: false,
            openReferal: false,
            referralOptions: '',
            selectedReferralOptions: '',
            facilityAddress: '',
            facilityCity: '',
            faciltiyState: '',
            searchOrganization: [],
            facilityZip: '',
            facilityPhone: '',
            facilityFax: '',
            facilityKey: '',
            is64baseimage: null,
            files: [],
            sweetOpenSuccess: false,
            messageToDisplay: '',
            alert: '',
            imageURL: '',
            openModel: false,
            showModal: false,
            isLoadingReferral: false,
            globalSummaryAccess: 0,
            sleepScreenerAccess: 0,
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        this.validator = new SimpleReactValidator({
            validators: {
                autoCompleteRequired: {  // name the rule
                    message: 'The :attribute field is required.',
                    rule: (val, params, validator) => {
                        if (!val.value) {
                            return false;
                        }
                    },
                }
            }
        });
    }
    handleClose = () => {
        this.setState({ openModel: false })
    }
    handleOpenModel = () => {
        this.setState({ openModel: true })
    }

    componentDidMount = async () => {
        const options = {
            params: {
                "ModuleName": "Users",
                "LoggedInUserId": 1,
                "IsSuperAdmin": 1,
                "Search": this.state.textToSearch,
                "OrderByFieldParam": this.state.sortBy,
                "SortOrderParam": this.state.currentSortOrder,
                "PageSize": this.state.rowsPerPage,
                "RowsToSkip": this.state.rowsToSkip
            }
        }

        this.setState({
            isPapAccountOption: [
                { 'value': '', 'label': 'Is Pap Account?' },
                { 'value': 2, 'label': 'No' },
                { 'value': 1, 'label': 'Yes' },
            ]
        })
        const roleOptions = {
            params: {
                "Search": "",
            },
        };

        // await this.fetchUserRole(roleOptions)
        await this.fetchUserOrganization(roleOptions)
        if (this.props.match.params.userId) {
            await this.fetchUserDetail(this.props.match.params.userId)
        }
    }
    renderProfileImage = (url, avatar = null) => {
        if (!this.state.IsDeleteImage && avatar)
            return <div><img src={url} className="profile-image" />&nbsp;&nbsp;&nbsp;
                <img src='https://d30y9cdsu7xlg0.cloudfront.net/png/53504-200.png' onClick={this.closeClick.bind(this)} style={{ cursor: 'pointer', marginBottom: '50px', width: '20px' }} /></div>
        else
            return ''
    }
    handleError = async () => {

        this.setState({
            messageToDisplay: '',
            sweetOpenError: false
        })

    };
    handleSelectChange = (field, value, reason) => {

        if (field == 'referralSearch' && value && value.length >= 4) {
            this.fetchUserReferal(value);
        }
        else {
            this.setState({
                [field]: value
            })
        }
        	
        if (field == 'is_pap_account' && value) {
            if (value.value === 1) {
                this.setState({ isPapSelected: true })
            }
            else {
                this.setState({ isPapSelected: false })
            }
        }

        if (field == 'is_pap_account' && value) {
            if (value.value === 1) {
                this.setState({ isPapSelected: true })
            }
            else {
                this.setState({ isPapSelected: false })
            }
        }

        // if (field === 'organization' || field === 'referral') {
        //     this.setState({
        //         [field]: value
        //     })
        // }
        // else {
        //     if (field == 'referralSearch' && value && value.length >= 4) {
        //         this.fetchUserReferal(value);
        //     }
        // }
    }

    fetchUserRole = async (options) => {

        await UserCreateApi.get('/user/getroleandorganization', options)
            .then((res) => res.data.success && res.data.liRoleResponse.map(role => ({
                'value': role.id,
                'label': role.name
            })))
            .then((roles) =>
                this.setState({
                    roles: [{ 'value': '', 'label': 'Pick a Role' }, ...roles]
                }))
    }

    fetchUserOrganization = async (options) => {

        await UserCreateApi.get('/user/getroleandorganization', options)
            .then((res) => {
                if (res.data.success) {
                    let organizations = res.data.liOrganizationResponse && res.data.liOrganizationResponse.map(organization => ({
                        'value': organization.nickName,
                        'label': organization.nickName
                    }));

                    let roles = res.data.liRoleResponse && res.data.liRoleResponse.map(role => ({
                        'value': role.id,
                        'label': role.display_name
                    }))

                    if (IsReferralAdmin()) {
                        const filterData = []
                        res.data.liRoleResponse.map(item => {
                            if (item.display_name.toLowerCase() === "referral user" || item.display_name.toLowerCase() === "referral admin" || item.display_name.toLowerCase() === "referral-user" || item.display_name.toLowerCase() === "referral-admin") {
                                filterData.push(item)
                            }
                        })

                        roles = filterData.map(role => ({
                            'value': role.id,
                            'label': role.display_name
                        }))
                    }

                    this.setState({
                        organizations: organizations,
                        roles: roles
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    fetchUserReferal = async (refferalSearch) => {
        if (cancel !== undefined) {
            cancel();
        }
        let isMounted = true; // note this flag denote mount status
        let searchOrganization = this.state.organization && this.state.organization.map(function (item) { return item['value']; }).join();
        this.setState({ isLoadingReferral: true });
        // this.state.organizations.filter((o) => {
        //     return userOrganization.includes(o.value)
        // })
        let authToken = JSON.parse(localStorage.getItem("persist:userData")).authToken;
        var user = JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user);

        const options = {
            headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replaceAll('"', '')}`, "UserId": `${user.userId}` },
            params: {
                "OrganizationParam": searchOrganization, // send selected organization StLukesHS,MPCS,MCMS,OHH,QMES
                "FacilityAddress": this.state.facilityAddress,
                "FacilityCity": this.state.facilityCity,
                "FacilityState": this.state.facilityState,
                "FacilityZip": this.state.facilityZip,
                "FacilityPhone": this.state.facilityPhone,
                "FacilityFax": this.state.facilityFax,
                "FacilityKey": this.state.facilityKey,
                "LimitParam": 100000,
                "OffsetParam": 0,
                "OrderByFieldParam": "",
                "SortOrderParam": "",
                "SearchParam": refferalSearch,
                "Id": "" // send selected refferal key
            },
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            })
        }
        await axios.get(`${process.env.REACT_APP_API_URL}api/dashboard/getreferralsearchlist`, options)
            .then((res) => {
                let refData = '';
                if (res.data.success) {
                    refData = res.data.liGetReferralSearch && res.data.liGetReferralSearch.map(referral => ({
                        'value': referral.referralKey ? referral.referralKey : '',
                        'label': referral.referral ? referral.referral : '',
                        'referralType': referral.referralType ? referral.referralType : ''
                    }))
                }

                this.setState({
                    referralOptions: refData,
                    isLoadingReferral: false
                });
            })
            .catch(function (error) {
                console.log(error);
            });


        // await UserCreateApi.get('dashboard/getreferralsearchlist',options)
        //     .then((res) => isMounted && res.data.liGetReferralSearch && res.data.liGetReferralSearch.map(referral =>({
        //         'value':referral.referralKey,
        //         'label':referral.referral
        //     })))
        //     .then((referralOptions) => isMounted && referralOptions && this.setState({
        //         referralOptions
        //     }))

        // if (isMounted) {
        //     this.setState({
        //         facilityAddress: '',
        //         facilityCity: '',
        //         facilityState: '',
        //         facilityZip: '',
        //         facilityPhone: '',
        //         facilityFax: '',
        //         facilityKey: '',
        //     })
        // }
    }

    onSearchReferal = async () => {
        this.setState({ isLoadingReferral: true })
        const options = {
            params: {
                "OrganizationParam": this.state.searchOrganization,
                "FacilityAddress": this.state.facilityAddress,
                "FacilityCity": this.state.facilityCity,
                "FacilityState": this.state.facilityState,
                "FacilityZip": this.state.facilityZip,
                "FacilityPhone": this.state.facilityPhone,
                "FacilityFax": this.state.facilityFax,
                "FacilityKey": this.state.facilityKey,
                "LimitParam": 10,
                "OffsetParam": 0,
                "OrderByFieldParam": "",
                "SortOrderParam": "",
                "SearchParam": '',
                "Id": ""
            }
        }
        await UserCreateApi.get('dashboard/getreferralsearchlist', options)
            .then((res) => res.data.liGetReferralSearch && res.data.liGetReferralSearch.map(referral => ({
                'value': referral.referralKey,
                'label': referral.referral,
                'referralType': referral.referralType
            })))
            .then((referralOptions) => referralOptions && this.setState({
                referralOptions,
                isLoadingReferral: false
            }))
            .then(this.handleClose())
    }

    displayAlert = (title, message, type) => {
        if (type == 'success') {
            this.setState({
                alert: < SweetAlert
                    success
                    title={title}
                    onConfirm={() => this.hideModel()} >
                    {message}
                </SweetAlert>,
                showModal: !this.state.showModal,
            })
        }
        else {
            this.setState({
                alert: < SweetAlert
                    error
                    title={title}
                    onConfirm={() => this.hideModel()} >
                    {message}
                </SweetAlert>,
                showModal: !this.state.showModal,
            })
        }
    }

    hideModel = () => {
        this.setState({ alert: '' })
        this.props.history.push('/users');
    }

    fetchUserDetail = async (userId) => {

        const options = {
            params: {
                "id": userId,
            }
        }
        await UserCreateApi.get('/user/getuserbyid', options)
            .then((res) => {
                if (res.data.success == true) {
                    let userDetails = res.data.liUserByIDResponse[0];
                    let roleSelectedOption = this.state.roles.find((o) => { return o.value == userDetails.roleId })
                    let referalSelectedOption = []
                    let organizationSelectedOption = []

                    if (userDetails.organization && userDetails.organization != '') {
                        let userOrganization = userDetails.organization.split(',')
                        organizationSelectedOption = this.state.organizations.filter((o) => {
                            return userOrganization.includes(o.value)
                        })
                    }

                    const options = {
                        params: {
                            "OrganizationParam": userDetails.organization,
                            "FacilityAddress": this.state.facilityAddress,
                            "FacilityCity": this.state.facilityCity,
                            "FacilityState": this.state.facilityState,
                            "FacilityZip": this.state.facilityZip,
                            "FacilityPhone": this.state.facilityPhone,
                            "FacilityFax": this.state.facilityFax,
                            "FacilityKey": this.state.facilityKey,
                            "LimitParam": 10,
                            "OffsetParam": 0,
                            "OrderByFieldParam": "",
                            "SortOrderParam": "",
                            "SearchParam": '',
                            "Id": userDetails.referral,
                            "RequestForGetUserDetails": userDetails.userId
                        }
                    }
                    UserCreateApi.get('dashboard/getreferralsearchlist', options)
                        .then((res) => res.data.liGetReferralSearch && res.data.liGetReferralSearch.map(referral => ({
                            'value': referral.referralKey,
                            'label': referral.referral,
                            'referralType': referral.referralType ? referral.referralType : ''
                        })))
                        .then((referral) => referral && this.setState({
                            referral
                        }))
                        .then(this.handleClose())
                    this.setState({
                        name: userDetails.name,
                        title: userDetails.title,
                        role: roleSelectedOption || "",
                        email: userDetails.email,
                        phone: userDetails.phone,
                        extension: userDetails.extension,
                        is_pap_account: userDetails.isPAPUser == 1 ? { 'value': 1, 'label': 'Yes' } : { 'value': 2, 'label': 'No' },
                        organization: organizationSelectedOption,
                        avatar: userDetails.avatar,
                        imageURL: process.env.REACT_APP_API_IMAGE_URL + res.data.imagePath,
                        editPageRoleId: userDetails.roleId,
                        globalSummaryAccess: userDetails.globalSummaryAccess,
                        sleepScreenerAccess: userDetails.sleepScreenerAccess,
                        screenerEmailFrequency: userDetails.screenerEmailFrequency,
                        isLoading: false,
                        papType: userDetails.papType,
                        airviewName: userDetails.airviewName,
                        airviewOrganizationName: userDetails.airviewOrganizationName,
                        encoreName: userDetails.encoreName,
                        encoreSleepLab: userDetails.encoreSleepLab,
                        isPapSelected: userDetails.isPAPUser == 1 ? true : false
                    });
                    papOptionsLoaded = true;
                }
                else {
                    this.displayAlert(res.data.message, '', 'error')
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    getFiles(files) {
        this.setState({ files: files })
        this.setState({ isError: false, error: '' })
        if (files && files.name.length > 0) {
            if (files.size.split(' ')[0] / 1024 > 5) {
                this.setState({ isError: true, error: 'image should be smaller than 5 MB' })
            }
            var type = files.name.split('.')[1] // image/jpg, image/png, image/jpeg...
            // allow jpg, png, jpeg, bmp, gif, ico
            var Extension = files.name.split('.')[1].toLowerCase();
            if (Extension == "gif" || Extension == "png" || Extension == "bmp" || Extension == "jpeg" || Extension == "jpg") {

                this.setState({
                    is64baseimage: files.base64.split(',')[1],
                    avatar: files.name
                })
            }
            else {
                this.setState({ isError: true, error: 'Only file with the .gif, .png, .bmp, .jpeg, .jpg extension are allowed' })
            }
            this.setState({
                imageURL: files.base64
            });
        }
        else {
            this.setState({
                is64baseimage: null,
                avatar: null
            });
        }
    }

    onClickReset = () => {
        this.setState({
            facilityAddress: '',
            facilityCity: '',
            facilityState: '',
            facilityZip: '',
            facilityPhone: '',
            facilityFax: '',
            facilityKey: '',
        })
    }

    handleChange = (event) => {
        let value = event.target.value
        if (event.target && (event.target.name == 'password' || event.target.name == 'password_confirmation')) {
            value = value.replace(/\s/g, '');
        }
        this.setState({ [event.target.name]: value });
    }

    handleAirtViewCheckbox = (e) => {
        var name = [e.target.name];
        if ([e.target.name] == 'airviewNameCheckbox') {
            this.setState({
                [e.target.name]: !this.state.airviewNameCheckbox
            });
            if (!e.target.checked) {
                this.setState({ isErrorInAirView: false });
            }
        }
        else if ([e.target.name] == 'encoreNameCheckbox') {
            this.setState({
                [e.target.name]: !this.state.encoreNameCheckbox
            });
            if (!e.target.checked) {
                this.setState({ isErrorInEncoreView: false });
            }
        }
        isChangedEvent = 1;
    }

    airviewInfo() {
        const openPdfDocumentUrl = window.location.origin + '/pdfs/HelpDocumentForIdentifyOrganization.pdf';
        return (<OverlayTrigger
            placement="top"
            overlay={
                <BootstrapTooltip id={`tooltip-top`}>
                    <strong>Click for help finding this information</strong>
                </BootstrapTooltip>
            }
        ><a href={openPdfDocumentUrl} target="_blank"><FontAwesomeIcon icon={["fa", "info"]} style={{ fontSize: 'small', cursor: 'pointer', color: '#34bfa3' }} /></a></OverlayTrigger>)
    }

    showHideCareOrchestratorPhilipsInfoModal = () => {
        this.setState({ isShowCareOrchestratorPhilipsInfo: !this.state.isShowCareOrchestratorPhilipsInfo });
    }

    careOrchestratorPhilipsInfo = () => {
        const openPhilipUrl = window.location.origin + '/images/Philips.png';

        return (
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <BootstrapTooltip id={`tooltip-top`}>
                            <strong>Click for help finding this information</strong>
                        </BootstrapTooltip>
                    }
                ><FontAwesomeIcon onClick={this.showHideCareOrchestratorPhilipsInfoModal} icon={["fa", "info"]} style={{ fontSize: 'small', cursor: 'pointer', color: '#34bfa3' }} />
                </OverlayTrigger>
                {
                    (this.state.isShowCareOrchestratorPhilipsInfo) ? (<Modal1
                        className="sales-filters profile-change-pwd philips-modal-profile"
                        show={this.state.isShowCareOrchestratorPhilipsInfo}
                        onHide={this.showHideCareOrchestratorPhilipsInfoModal}
                        backdrop="static"
                        keyboard={false}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                    >
                        <Modal1.Header closeButton> </Modal1.Header>
                        <Modal1.Body>
                            <div className="form-group text-center">
                                <div className="col-sm-12 philip-img">
                                    <img src={openPhilipUrl} />
                                </div>
                            </div>
                        </Modal1.Body>
                        <Modal1.Footer>
                            <Button onClick={this.showHideCareOrchestratorPhilipsInfoModal} className={`btn btn-secondary close-filter-popup ml-auto phillips-modal-btn`}> Cancel</Button>
                        </Modal1.Footer>
                    </Modal1>) : ''
                }
            </>
        )
    }

    handleAirtViewCheckbox = (e) => {
        var name = [e.target.name];
            if ([e.target.name] == 'airviewNameCheckbox') {
                this.setState({
                    [e.target.name]: !this.state.airviewNameCheckbox
                });
                if (!e.target.checked) {
                    this.setState({ isErrorInAirView: false });
                }
            }
            else if ([e.target.name] == 'encoreNameCheckbox') {
                this.setState({
                    [e.target.name]: !this.state.encoreNameCheckbox
                });
                if (!e.target.checked) {
                    this.setState({ isErrorInEncoreView: false });
                }
            }
        isChangedEvent = 1;
    }

    airviewInfo() {
        const openPdfDocumentUrl = window.location.origin + '/pdfs/HelpDocumentForIdentifyOrganization.pdf';
        return (<OverlayTrigger
            placement="top"
            overlay={
                <BootstrapTooltip id={`tooltip-top`}>
                    <strong>Click for help finding this information</strong>
                </BootstrapTooltip>
            }
        ><a href={openPdfDocumentUrl} target="_blank"><FontAwesomeIcon icon={["fa", "info"]} style={{ fontSize: 'small', cursor: 'pointer', color: '#34bfa3' }} /></a></OverlayTrigger>)
    }

    showHideCareOrchestratorPhilipsInfoModal = () => {
        this.setState({ isShowCareOrchestratorPhilipsInfo: !this.state.isShowCareOrchestratorPhilipsInfo });
    }

    careOrchestratorPhilipsInfo = () => {
        const openPhilipUrl = window.location.origin + '/images/Philips.png';

        return (
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <BootstrapTooltip id={`tooltip-top`}>
                            <strong>Click for help finding this information</strong>
                        </BootstrapTooltip>
                    }
                ><FontAwesomeIcon onClick={this.showHideCareOrchestratorPhilipsInfoModal} icon={["fa", "info"]} style={{ fontSize: 'small', cursor: 'pointer', color: '#34bfa3' }} />
                </OverlayTrigger>
                {
                    (this.state.isShowCareOrchestratorPhilipsInfo) ? (<Modal1
                        className="sales-filters profile-change-pwd philips-modal-profile"
                        show={this.state.isShowCareOrchestratorPhilipsInfo}
                        onHide={this.showHideCareOrchestratorPhilipsInfoModal}
                        backdrop="static"
                        keyboard={false}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                    >
                        <Modal1.Header closeButton> </Modal1.Header>
                            <Modal1.Body>
                                <div className="form-group text-center">
                                    <div className="col-sm-12 philip-img">
                                        <img src={openPhilipUrl} />
                                    </div>
                                </div>
                            </Modal1.Body>
                        <Modal1.Footer>
                            <Button onClick={this.showHideCareOrchestratorPhilipsInfoModal} className={`btn btn-secondary close-filter-popup ml-auto phillips-modal-btn`}> Cancel</Button>
                        </Modal1.Footer>
                        </Modal1>) : ''
                }
            </>
        )
    }

    handleFormSubmit(event) {
        event.preventDefault();
        if (this.validator.allValid()) {
            this.setState({ submitBtnDisabled: true });

            let papType = '';
            
             if (isChangedEvent === 0) {
                 papType = this.props.initialValues.papType;
             }
             if (this.state.airviewNameCheckbox == true && this.state.encoreNameCheckbox == true) {
                 papType = 'Both';
             }
             else if (this.state.airviewNameCheckbox == true) {
                 papType = 'AirView';
             }
             else if (this.state.encoreNameCheckbox == true) {
                 papType = 'Encore';
             }
             else {
                 papType = '';
             }
            
             if (papType == 'Both') {
                 if (!this.state.airviewName || !this.state.airviewOrganizationName || this.state.airviewName == '' || this.state.airviewOrganizationName == '' || !this.state.encoreName || !this.state.encoreSleepLab || this.state.encoreName == '' || this.state.encoreSleepLab == '') {
                this.displayAlert('Please enter PAP portal integration details', 'error');
                if (this.state.airviewName == '' || !this.state.airviewName) {
                    this.setState({ isErrorInAirView: true });
                    this.setState({ submitBtnDisabled: false });
                }
                if (this.state.airviewOrganizationName == '' || !this.state.airviewOrganizationName) {
                    this.setState({ isErrorInAirView: true });
                    this.setState({ submitBtnDisabled: false });
                }
                if (this.state.encoreName == '' || !this.state.encoreName) {
                    this.setState({ isErrorInEncoreView: true })
                    this.setState({ submitBtnDisabled: false });
                }
                if (this.state.encoreSleepLab == '' || !this.state.encoreSleepLab) {
                    this.setState({ isErrorInEncoreView: true });
                    this.setState({ submitBtnDisabled: false });
                }
                this.setState({ submitBtnDisabled: false });
                return false;
                }
            }
            else if (papType == 'AirView') {
                if (!this.state.airviewName || !this.state.airviewOrganizationName || this.state.airviewName == '' || this.state.airviewOrganizationName == '') {
                    this.displayAlert('Please enter PAP portal integration details', 'error');
                    if (this.state.airviewName == '' || !this.state.airviewName) {
                        this.setState({ isErrorInAirView: true })
                        this.setState({ submitBtnDisabled: false });
                    }
                    if (this.state.airviewOrganizationName == '' || !this.state.airviewOrganizationName) {
                        this.setState({ isErrorInAirView: true })
                        this.setState({ submitBtnDisabled: false });
                    }
                    this.setState({ submitBtnDisabled: false });
                    return false;
                }
            }
            else if (papType == 'Encore') {
                if (!this.state.encoreName || !this.state.encoreSleepLab || this.state.encoreName == '' || this.state.encoreSleepLab == '') {
                    this.displayAlert('Please enter PAP portal integration details', 'error');
                    if (this.state.encoreName == '' || !this.state.encoreName) {
                        this.setState({ isErrorInEncoreView: true })
                        this.setState({ submitBtnDisabled: false });
                    }
                    if (this.state.encoreSleepLab == '' || !this.state.encoreSleepLab) {
                        this.setState({ isErrorInEncoreView: true })
                        this.setState({ submitBtnDisabled: false });
                    }
                    this.setState({ submitBtnDisabled: false });
                    return false;
                }
            }

            let organization = IsReferralAdmin() ? this.props.organizationParam : this.state.organization.map(function (item) { return item['value']; }).join()
            let referral = IsReferralAdmin() ? this.props.referralParam : this.state.referral.map(function (item) { return item['value']; }).join()
            let referralType = IsReferralAdmin() ? this.props.referralParam : this.state.referral.map(function (item) { return item['referralType']; }).join()
            let pap_ac = this.state.is_pap_account && this.state.is_pap_account.value.toString() == '2' ? "0" : "1"
            let userId = "0"
            let password = '';
            let CurrentImageName = this.state.avatar;
            if (this.props.match.params.userId) {
                userId = this.props.match.params.userId.toString()
                password = this.state.password
            }

            const formData = {
                "StatementType": userId && userId == "0" ? "insert" : "update",
                'Name': this.state.name,
                "Id": userId,
                'Email': this.state.email,
                "Password": password,
                'Title': this.state.title,
                'Phone': this.state.phone,
                'RoleId': this.state.role.value,
                "Extension": this.state.extension,
                "Is_pap_user": pap_ac,
                "Avatar": "",
                'Organizations': organization,
                'Referrals': referral,
                // "CurrentImageName": CurrentImageName,
                "IsDeleteImage": this.state.IsDeleteImage,
                // "ImageData": this.state.is64baseimage ? this.state.is64baseimage : '',
                "GlobalSummaryAccess": parseInt(this.state.globalSummaryAccess),
                "sleepScreenerAccess": parseInt(this.state.sleepScreenerAccess),
                "screenerEmailFrequency": this.state.screenerEmailFrequency,
                "airviewName": this.state.airviewName,
                "AirviewOrganizationName": this.state.airviewOrganizationName,
                "EncoreName": this.state.encoreName,
                "EncoreSleepLab": this.state.encoreSleepLab,
                "PapType": papType,
                "ReferralType": referralType
            };

            UserCreateApi.post('user/addandupdateuser', formData)
                .then((res) => {
                    this.displayAlert(res.data.message, '', res.data.success == true ? 'success' : 'error')
                    this.setState({ submitBtnDisabled: false });
                });
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    redirectToUserListing = () => {
        this.props.history.push('/users');
    }

    // renderEmail(){
    //     if(userId)
    //     return
    // }

    closeClick(IsDelete) {
        this.setState({ IsDeleteImage: true });
    }

    handleGlobalSummaryAccessChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSleepScreenerAccessChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        const { showModal } = this.state;
        var globalSummaryAccessOptions = [
            { value: 0, lable: 'No' },
            { value: 1, lable: 'Yes' },
        ]

        var sleepScreenerAccessOptions = [
            { value: 0, lable: 'None' },
            { value: 1, lable: 'View Only' },
            { value: 2, lable: 'View and Edit' },
        ]

        isLoadFirstTime++;
        let airviewNameCheckboxDefaultChecked = false;
        let encoreNameCheckboxDefaultChecked = false;
        if (isLoadFirstTime === 4) {
            if (this.props.initialValues.papType == 'Both') {
                airviewNameCheckboxDefaultChecked = true;
                encoreNameCheckboxDefaultChecked = true;
                this.setState({
                    airviewNameCheckbox: !this.state.airviewNameCheckbox,
                    encoreNameCheckbox: !this.state.encoreNameCheckbox,
                });
            }
            else if (this.props.initialValues.papType == 'AirView') {
                airviewNameCheckboxDefaultChecked = true;
                encoreNameCheckboxDefaultChecked = false;
                this.setState({
                    airviewNameCheckbox: !this.state.airviewNameCheckbox
                });
            }
            else if (this.props.initialValues.papType == 'Encore') {
                encoreNameCheckboxDefaultChecked = true;
                airviewNameCheckboxDefaultChecked = false;
                this.setState({
                    encoreNameCheckbox: !this.state.encoreNameCheckbox,
                });
            }
            isLoadFirstTime = 5;
        }
        if (papOptionsLoaded) {
            papOptionsLoaded = false;
            if (this.state.papType == "Both") {
                airviewNameCheckboxDefaultChecked = true;
                encoreNameCheckboxDefaultChecked = true;
                this.setState({
                    airviewNameCheckbox: !this.state.airviewNameCheckbox,
                    encoreNameCheckbox: !this.state.encoreNameCheckbox,
                });
            }
            else if (this.state.papType == "AirView") {
                airviewNameCheckboxDefaultChecked = true;
                encoreNameCheckboxDefaultChecked = false;
                this.setState({
                    airviewNameCheckbox: !this.state.airviewNameCheckbox
                });
            }
            else if (this.state.papType == "Encore") {
                encoreNameCheckboxDefaultChecked = true;
                airviewNameCheckboxDefaultChecked = false;
                this.setState({
                    encoreNameCheckbox: !this.state.encoreNameCheckbox,
                });
            }
            isLoadFirstTime = 1;
            this.setState({ papType: "" });
        }

        else if (this.state.airviewNameCheckbox && this.state.encoreNameCheckbox) {
            airviewNameCheckboxDefaultChecked = true;
            encoreNameCheckboxDefaultChecked = true;
        }
        else if (this.state.airviewNameCheckbox) {
            airviewNameCheckboxDefaultChecked = true;
        }
        else if (this.state.encoreNameCheckbox) {
            encoreNameCheckboxDefaultChecked = true;
        }
        
        if (airviewNameCheckboxDefaultChecked) {
            if (document.getElementById('airviewNameCheckbox'))
                document.getElementById('airviewNameCheckbox').checked = true;
        }
        if (encoreNameCheckboxDefaultChecked) {
            if (document.getElementById('encoreNameCheckbox'))
                document.getElementById('encoreNameCheckbox').checked = true;
        }

        const body = (
            <div className="modal">
                <div onClick={this.handleClose}>X</div>
                <div className="moda-content">
                    <div className="modal-header">
                        <h2 id="simple-modal-title" style={{ color: 'red' }} >Text in a modal</h2>
                        <p id="simple-modal-description">
                            Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                        </p>
                    </div>

                </div>
            </div>
        );

        const { intl } = this.props;
        const data = this.props.dashboardData;

        const { loading } = this.props;
        const spinner = <span className="loader"></span>;

        return (
            <>
                {
                    showModal ? (
                        <Modal>
                            {this.state.alert}
                        </Modal>
                    ) : null
                }
                <Helmet>
                    <title>Add/Edit User | Scorecard</title>
                </Helmet>
                <div className="main-content-body user-create-edit bg-white">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-3 left-side-bar">
                                <MenuLeftNav isExpand={{ expand: "user", active: "adduser" }}></MenuLeftNav>
                            </div>
                            <div className="col-lg-9 mt-3  mb-5 right-content-wrap">
                                <div className="order-and-adherence-detail">
                                    <div className="form-inline px-0 jc-between" style={{ height: '65px' }}>
                                        <div className="manage-user-title">
                                            <span className="font-500">Manage Users</span>
                                        </div>
                                    </div>

                                    <div className="font-500 order-and-adherence-details-data  px-0">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="card">
                                                    <div className="card-header" style={{ backgroundColor: 'white' }}>
                                                        <div className="card-title"><h5 style={{ color: 'black' }}>{this.props.match.params.userId ? 'Edit User' : 'Add User'}</h5></div>
                                                    </div>
                                                    <div className="card-body text-center">
                                                        <Loader show={this.state.isLoading} message={spinner}>
                                                            <form onSubmit={this.handleFormSubmit}>
                                                                <div className="formgroup row">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Name<sup style={{ color: "red" }}> *</sup></label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <input
                                                                            type="text"
                                                                            name="name"
                                                                            placeholder="Please enter your name"
                                                                            value={this.state.name}
                                                                            onChange={this.handleChange}
                                                                            className="form-control"
                                                                            onClick={() => this.validator.showMessageFor('name')} />
                                                                        {this.validator.message('name', this.state.name, 'required|string|min:3|max:100', { className: 'text-danger' })}
                                                                    </div>
                                                                </div>

                                                                <div className="formgroup row">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Title<sup style={{ color: "red" }}> *</sup></label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <input
                                                                            type="text"
                                                                            name="title"
                                                                            placeholder="Please enter your title"
                                                                            value={this.state.title}
                                                                            onChange={this.handleChange}
                                                                            className="form-control"
                                                                            onClick={() => this.validator.showMessageFor('title')} />
                                                                        {this.validator.message('title', this.state.title, 'required|string|max:100', { className: 'text-danger' })}
                                                                    </div>
                                                                </div>

                                                                <div className="formgroup row text-center">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Role<sup style={{ color: "red" }}> *</sup></label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <Autocomplete
                                                                            name="role"
                                                                            id="asynchronous-demo"
                                                                            disabled={(this.props.match.params.userId && this.state.editPageRoleId === 1) ? true : false}
                                                                            defaultValue={{ 'value': '', 'label': 'Pick a Role' }}
                                                                            getOptionSelected={(option, value) => {
                                                                                return option.value == value.value
                                                                            }}
                                                                            getOptionLabel={(option) => option.label}
                                                                            options={this.state.roles || []}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    variant="outlined"
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        endAdornment: (
                                                                                            <React.Fragment>
                                                                                                {params.InputProps.endAdornment}
                                                                                            </React.Fragment>
                                                                                        ),
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            value={this.state.role}
                                                                            onChange={(e, value, reason) => this.handleSelectChange('role', value, reason)}
                                                                            onFocus={() => this.validator.showMessageFor('role')}
                                                                        />
                                                                        {this.validator.message('role', this.state.role, 'autoCompleteRequired', { className: 'text-danger' })}
                                                                    </div>
                                                                </div>

                                                                <div className="formgroup row">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Email<sup style={{ color: "red" }}> *</sup></label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        {(!this.props.match.params.userId) ? (<input
                                                                            type="text"
                                                                            name="email"
                                                                            placeholder="Please enter your email"
                                                                            value={this.state.email}
                                                                            onChange={this.handleChange}
                                                                            className="form-control"
                                                                            onClick={() => this.validator.showMessageFor('email')} />
                                                                        ) : (<input
                                                                            type="text"
                                                                            name="email"
                                                                            placeholder="Please enter your email"
                                                                            value={this.state.email}
                                                                            onChange={this.handleChange}
                                                                            className="form-control"
                                                                            disabled="disabled"
                                                                            onClick={() => this.validator.showMessageFor('email')} />)}
                                                                        {this.validator.message('email', this.state.email, 'required|email', { className: 'text-danger' })}
                                                                    </div>
                                                                </div>

                                                                <div className="formgroup row">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Phone</label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <input
                                                                            type="text"
                                                                            name="phone"
                                                                            placeholder="Please enter your phone"
                                                                            value={this.state.phone}
                                                                            onChange={this.handleChange}
                                                                            className="form-control"
                                                                            onClick={() => this.validator.showMessageFor('phone')} />
                                                                        {this.validator.message('phone', this.state.phone, 'numeric|size:10', { className: 'text-danger' })}
                                                                    </div>
                                                                </div>

                                                                <div className="formgroup row">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Extension</label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <input
                                                                            type="text"
                                                                            name="extension"
                                                                            autoComplete="new-off"
                                                                            placeholder="Please enter your extension"
                                                                            value={this.state.extension}
                                                                            onChange={this.handleChange}
                                                                            className="form-control" />
                                                                    </div>
                                                                </div>

                                                                {(this.props.match.params.userId) && <><div className="formgroup row">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">New Password</label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <input
                                                                            type="password"
                                                                            name="password"
                                                                            autoComplete="new-password"
                                                                            placeholder="Please enter new password"
                                                                            value={this.state.password}
                                                                            onChange={this.handleChange}
                                                                            className="form-control" />
                                                                        {this.validator.message('password', this.state.password, 'min:6', { className: 'text-danger' })}
                                                                    </div>
                                                                </div>
                                                                    <div className="formgroup row">
                                                                        <div className="col-lg-2 mt-3 text-right">
                                                                            <label htmlFor="title" className="custom-label">Confirm Password</label>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <input
                                                                                type="password"
                                                                                name="confirm_password"
                                                                                placeholder="Please enter confirm password"
                                                                                value={this.state.confirm_password}
                                                                                onChange={this.handleChange}
                                                                                className="form-control" />
                                                                            {this.validator.message('confirm_password', this.state.confirm_password, `in:${this.state.password}`, { className: 'text-danger' }, { messages: { in: 'Passwords need to match!' } })}
                                                                        </div>
                                                                    </div></>
                                                                }

                                                                <div className="formgroup row text-center">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Is Pap Account?<sup style={{ color: "red" }}> *</sup></label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <Autocomplete
                                                                            name="is_pap_account"
                                                                            id="asynchronous-demo2"
                                                                            getOptionLabel={(option) => option.label}
                                                                            options={this.state.isPapAccountOption}
                                                                            loading={loading}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    variant="outlined"
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        endAdornment: (
                                                                                            <React.Fragment>
                                                                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                                {params.InputProps.endAdornment}
                                                                                            </React.Fragment>
                                                                                        ),
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            value={this.state.is_pap_account}
                                                                            onChange={(e, value, reason) => this.handleSelectChange('is_pap_account', value, reason)}
                                                                        />
                                                                        {this.validator.message('is_pap_account', this.state.is_pap_account, 'autoCompleteRequired', { className: 'text-danger' })}
                                                                    </div>
                                                                </div>
                                                                {
                                                                    this.state.isPapSelected && <div className="pap-integration-popup" style={{ backgroundColor: '#f7f7f7', padding: '10px 40px' }}>
                                                                        <p className="main-heading" style={{ fontWeight: '600', fontSize: '16px', color: '#6b6969' }}>PAP Portal Integration</p>
                                                                        <p className="main-heading" style={{ fontWeight: '600', fontSize: '14px', color: '#6b6969' }}>Which PAP portal(s) do you use ? Select and provide integration details.</p>

                                                                        <p className="main-heading info-heading mt-3 mb-0" style={{ fontWeight: '600', fontSize: '16px', color: '#6b6969' }}>
                                                                            <label className="airviewLabel" for="airviewNameCheckbox">
                                                                                {airviewNameCheckboxDefaultChecked ?
                                                                                    <input id="airviewNameCheckbox" name="airviewNameCheckbox" type="checkbox" className="profile-check-box" value={this.state.airviewNameCheckbox} onClick={this.handleAirtViewCheckbox} />
                                                                                    : <input id="airviewNameCheckbox" name="airviewNameCheckbox" type="checkbox" className="profile-check-box" value={this.state.airviewNameCheckbox} onChange={this.handleAirtViewCheckbox} />}
                                                                                &nbsp; Airview (ResMed)</label>{this.airviewInfo()}</p>
                                                                        <div className="">
                                                                            <div className={`${clsx(
                                                                                {
                                                                                    "airview-red-border-error": this.state.isErrorInAirView
                                                                                }
                                                                            )}`}>
                                                                                <div className="formgroup row">
                                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                                        <label htmlFor="title" className="custom-label">Airview Name{this.state.airviewNameCheckbox && <sup style={{ color: "red" }}> *</sup>}</label>
                                                                                    </div>
                                                                                    <div className="col-lg-6">
                                                                                        <input
                                                                                            type="text"
                                                                                            name="airviewName"
                                                                                            placeholder="Please enter airview name"
                                                                                            value={this.state.airviewName}
                                                                                            className="form-control"
                                                                                            onChange={this.handleChange}
                                                                                            disabled={this.state.airviewNameCheckbox ? false : true} />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="formgroup row">
                                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                                        <label htmlFor="title" className="custom-label">Organization Name{this.state.airviewNameCheckbox && <sup style={{ color: "red" }}> *</sup>}</label>
                                                                                    </div>
                                                                                    <div className="col-lg-6">
                                                                                        <input
                                                                                            type="text"
                                                                                            name="airviewOrganizationName"
                                                                                            placeholder="Please enter airview organization"
                                                                                            value={this.state.airviewOrganizationName}
                                                                                            className="form-control"
                                                                                            onChange={this.handleChange}
                                                                                            disabled={this.state.airviewNameCheckbox ? false : true} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <p className="main-heading info-heading mb-0 mt-4" style={{ fontWeight: '600', fontSize: '16px', color: '#6b6969' }}>
                                                                            <label className="airviewLabel" for="encoreNameCheckbox">
                                                                                {encoreNameCheckboxDefaultChecked ?
                                                                                    <input id="encoreNameCheckbox" name="encoreNameCheckbox" type="checkbox" className="profile-check-box" value={this.state.encoreNameCheckbox} onChange={this.handleAirtViewCheckbox} />
                                                                                    : <input id="encoreNameCheckbox" name="encoreNameCheckbox" type="checkbox" className="profile-check-box" value={this.state.encoreNameCheckbox} onChange={this.handleAirtViewCheckbox} />}
                                                                                &nbsp; Care Orchestrator (Philips)</label>

                                                                            {this.careOrchestratorPhilipsInfo()}</p>
                                                                        <div className={`${clsx(
                                                                            {
                                                                                "airview-red-border-error": this.state.isErrorInEncoreView
                                                                            }
                                                                        )}`}>
                                                                            <div className="formgroup row">
                                                                                <div className="col-lg-2 mt-3 text-right">
                                                                                    <label htmlFor="title" className="custom-label">Name{this.state.encoreNameCheckbox && <sup style={{ color: "red" }}> *</sup>}</label>
                                                                                </div>
                                                                                <div className="col-lg-6">
                                                                                    <input
                                                                                        type="text"
                                                                                        name="encoreName"
                                                                                        placeholder="Please enter care orchestrator name"
                                                                                        value={this.state.encoreName}
                                                                                        className="form-control"
                                                                                        onChange={this.handleChange}
                                                                                        disabled={this.state.encoreNameCheckbox ? false : true} />
                                                                                </div>
                                                                            </div>
                                                                            <div className="formgroup row">
                                                                                <div className="col-lg-2 mt-3 text-right">
                                                                                    <label htmlFor="title" className="custom-label">Organization Name{this.state.encoreNameCheckbox && <sup style={{ color: "red" }}> *</sup>}</label>
                                                                                </div>
                                                                                <div className="col-lg-6">
                                                                                    <input
                                                                                        type="text"
                                                                                        name="encoreSleepLab"
                                                                                        placeholder="Please enter organization name"
                                                                                        value={this.state.encoreSleepLab}
                                                                                        className="form-control"
                                                                                        onChange={this.handleChange}
                                                                                        disabled={this.state.encoreNameCheckbox ? false : true} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className="formgroup row text-center">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Global Summary Access</label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <select name="globalSummaryAccess" onChange={this.handleGlobalSummaryAccessChange} className="form-control" >
                                                                            {globalSummaryAccessOptions.map((globalSummaryAccessOption, index) => {
                                                                                if (globalSummaryAccessOption.value === this.state.globalSummaryAccess) {
                                                                                    return <option selected={true} value={globalSummaryAccessOption.value}>{globalSummaryAccessOption.lable}</option>;
                                                                                }
                                                                                else {
                                                                                    return <option value={globalSummaryAccessOption.value}>{globalSummaryAccessOption.lable}</option>;
                                                                                }
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                {IsReferralAdmin() === false && <>
                                                                    <div className="formgroup row text-center">
                                                                        <div className="col-lg-2 mt-3 text-right">
                                                                            <label htmlFor="title" className="custom-label">Organization<sup style={{ color: "red" }}> *</sup></label>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Autocomplete
                                                                                name="organization"
                                                                                id="tags-standard"
                                                                                getOptionLabel={(option) => option.label}
                                                                                options={this.state.organizations || []}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        variant="outlined"
                                                                                        InputProps={{
                                                                                            ...params.InputProps,
                                                                                            endAdornment: (
                                                                                                <React.Fragment>

                                                                                                    {params.InputProps.endAdornment}
                                                                                                </React.Fragment>
                                                                                            ),
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                                value={this.state.organization}
                                                                                onChange={(e, value, reason) => this.handleSelectChange('organization', value, reason)}
                                                                                multiple
                                                                                onClick={() => this.validator.showMessageFor('organization')}
                                                                            />
                                                                            {this.validator.message('organization', this.state.organization, 'required', { className: 'text-danger' })}
                                                                        </div>
                                                                        <div style={{ marginLeft: '140px', marginTop: '0px' }}></div>
                                                                    </div>

                                                                    <div className="formgroup row text-center">
                                                                        <div className="col-lg-2 mt-3 text-right">
                                                                            <label htmlFor="title" className="custom-label">Referral<sup style={{ color: "red" }}> *</sup></label>
                                                                        </div>
                                                                        <div className={`col-lg-6 formgroup multiselect ${clsx(
                                                                            {
                                                                                "profile-refferal-loader": this.state.isLoadingReferral
                                                                            }
                                                                        )}`}>
                                                                            <div>
                                                                                <Autocomplete
                                                                                    multiple
                                                                                    name="referrral"
                                                                                    id="tags-standard5"
                                                                                    loading={this.state.isLoadingReferral}
                                                                                    getOptionLabel={(option) => option.label}
                                                                                    getOptionSelected={(option) => option == this.state.referralOptions}
                                                                                    options={this.state.referralOptions || []}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            variant="outlined"
                                                                                            placeholder="Enter at least 4 character"
                                                                                            InputProps={{
                                                                                                ...params.InputProps,
                                                                                                endAdornment: (
                                                                                                    <React.Fragment>

                                                                                                        {params.InputProps.endAdornment}
                                                                                                    </React.Fragment>
                                                                                                ),
                                                                                            }}

                                                                                        />
                                                                                    )}
                                                                                    value={this.state.referral}
                                                                                    onChange={(e, value, reason) => this.handleSelectChange('referral', value, reason)}
                                                                                    onInputChange={(e, value, reason) => this.handleSelectChange('referralSearch', value, reason)}
                                                                                    onBlur={() => this.validator.showMessageFor('referral')}
                                                                                />
                                                                            </div>
                                                                            {this.validator.message('referral', this.state.referral, 'required', { className: 'text-danger' })}
                                                                        </div>

                                                                        <div style={{ marginLeft: '140px', marginTop: '0px' }}></div>
                                                                    </div>

                                                                    <div className="formgroup row">
                                                                        <div className="col-lg-2"></div>
                                                                        <div className="col-lg-6 text-left">
                                                                            <button
                                                                                onClick={this.handleOpenModel}
                                                                                type="button"
                                                                                className={`btn btn-primary btn-elevate font-weight-bold`}>
                                                                                ADVANCE SEARCH
                                                                            </button>
                                                                            {(this.state.facilityAddress || this.state.facilityCity || this.state.facilityState || this.state.facilityZip || this.state.facilityPhone || this.state.facilityFax || this.state.facilityKey) &&
                                                                                <button
                                                                                    type="reset" onClick={this.onClickReset}
                                                                                    type="button"
                                                                                    className={`border btn btn-white btn-elevate font-weight-bold ml-2`}>
                                                                                    Reset
                                                                                </button>}
                                                                        </div>
                                                                    </div>
                                                                </>}
                                                                <div className="formgroup row text-center">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Sleep Screener Access</label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <select name="sleepScreenerAccess" onChange={this.handleSleepScreenerAccessChange} className="form-control" >
                                                                            {sleepScreenerAccessOptions.map((sleepScreenerAccessOption, index) => {
                                                                                if (sleepScreenerAccessOption.value === this.state.sleepScreenerAccess) {
                                                                                    return <option selected={true} value={sleepScreenerAccessOption.value}>{sleepScreenerAccessOption.lable}</option>;
                                                                                }
                                                                                else {
                                                                                    return <option value={sleepScreenerAccessOption.value}>{sleepScreenerAccessOption.lable}</option>;
                                                                                }
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="formgroup row text-center">
                                                                    <div className="col-lg-2 mt-3 text-right">
                                                                        <label htmlFor="title" className="custom-label">Notifications - Sleep Screener Results</label>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <select
                                                                            name="screenerEmailFrequency"
                                                                            className="form-control"
                                                                            onChange={this.handleSleepScreenerAccessChange}
                                                                        >
                                                                            {emailFrequencyOptions.map((emailFrequencyOption, index) => {
                                                                                if (emailFrequencyOption.value === this.state.screenerEmailFrequency) {
                                                                                    return <option selected={true} value={emailFrequencyOption.value}>{emailFrequencyOption.lable}</option>;
                                                                                }
                                                                                else {
                                                                                    return <option value={emailFrequencyOption.value}>{emailFrequencyOption.lable}</option>;
                                                                                }
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="row mt-3 pb-3">
                                                                    <div className="col-lg-2 mt-3 text-right"></div>
                                                                    <div className="col-lg-6 text-left add-edit-user-btn">
                                                                        <button type="submit" disabled={this.state.submitBtnDisabled} className={`btn btn-primary btn-elevate kt-login__btn-primary font-weight-bold mr-2`}>{this.state.submitBtnDisabled ? 'submitting...' : 'Submit'}</button>
                                                                        <button onClick={this.redirectToUserListing} type="reset" className={`border btn btn-white btn-elevate kt-login__btn-primary font-weight-bold`}>Cancel</button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </Loader>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <Dialog className="user-model" onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={this.state.openModel}>
                        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                            <FontAwesomeIcon icon={["fas", "filter"]} size='lg' />
                            Filter
                        </DialogTitle>
                        <DialogContent dividers>
                            <div className="modal-form-filter">
                                <div className="row">
                                    <div className="col-md-4">
                                        <form className="filter-form" autoComplete="off">
                                            <FormLabel className="">
                                                Facility Address
                                            </FormLabel>
                                            <Input className="" name="facilityAddress" type="text" placeholder="Facility Address" value={this.state.facilityAddress} onChange={(e) => this.setState({ facilityAddress: e.target.value })} />

                                            <FormLabel className="">
                                                Facility Zip
                                            </FormLabel>
                                            <Input className="" name="facilityZip" type="text" placeholder="Facility Zip" value={this.state.facilityZip} onChange={(e) => this.setState({ facilityZip: e.target.value })} />

                                            <FormLabel className="">
                                                Facility Key
                                            </FormLabel>
                                            <Input className="" name="facilityKey" type="text" placeholder="Facility Key" value={this.state.facilityKey} onChange={(e) => this.setState({ facilityKey: e.target.value })} />

                                        </form>

                                    </div>

                                    <div className="col-md-4">
                                        <form className="filter-form" autoComplete="off">
                                            <FormLabel className="">
                                                Facility City
                                            </FormLabel>
                                            <Input className="" name="facilityCity" type="text" placeholder="Facility City" value={this.state.facilityCity} onChange={(e) => this.setState({ facilityCity: e.target.value })} />

                                            <FormLabel className="">
                                                Facility Phone
                                            </FormLabel>
                                            <Input className="" name="facilityPhone" type="text" placeholder="Facility Phone" value={this.state.facilityPhone} onChange={(e) => this.setState({ facilityPhone: e.target.value })} />
                                        </form>
                                    </div>


                                    <div className="col-md-4">
                                        <form className="filter-form" autoComplete="off">
                                            <FormLabel className="">
                                                Facility State
                                            </FormLabel>
                                            <Input className="" name="facilityState" type="text" placeholder="Facility State" value={this.state.facilityState} onChange={(e) => this.setState({ facilityState: e.target.value })} />

                                            <FormLabel className="">
                                                Facility FAX
                                            </FormLabel>
                                            <Input className="" name="facilityFax" type="text" placeholder="Facility Fax" value={this.state.facilityFax} onChange={(e) => this.setState({ facilityFax: e.target.value })} />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>

                            <div className="modal-btns">
                                <Button autoFocus onClick={this.handleClose} type="button" className="btn btn-primary set-search-btn">Set Search Criteria
                                </Button>
                                <Button type="reset" onClick={this.onClickReset} className="btn btn-secondary reset-search-criteria">Reset</Button>
                                <Button type="button" onClick={this.handleClose} className="btn btn-secondary reset-close-criteria">close</Button>

                            </div>
                        </DialogActions>
                    </Dialog>
                </div>
            </>
        );

    }
}

function mapStateToProps(state) {
    // var parsedUserData = state.auth.user;
    // var AuthToken = state.auth.authToken;
    // let PtKey = '';
    // for (var parsedJson in parsedUserData) {
    //   PtKey = parsedUserData[parsedJson].PtKey;
    // }
    // console.log(state.auth.referralParam);
    // console.log(state.auth.organizationParam);
    return {
        // dashboardData: state.auth.dashboardData,
        // loading: state.auth.loading,
        // PtKey: PtKey,
        // AuthToken: AuthToken,
        referralParam: state.auth.referralParam,
        organizationParam: state.auth.organizationParam,
        initialValues: {
                isPapUser: state.auth.isPapUser ? state.auth.isPapUser : '',
                papType: state.auth.papType ? state.auth.papType : '',
                airviewName: state.auth.airviewName,
                airviewOrganizationName: state.auth.airviewOrganizationName,
                encoreName: state.auth.encoreName,
                encoreSleepLab: state.auth.encoreSleepLab,
                isPapUser: state.auth.isPapUser
        }
    }
}

Create = reduxForm({
    form: 'Create',
    validate,
    enableReinitialize: true,
    destroyOnUnmount: true
})(Create);

export default injectIntl(
    connect(
        mapStateToProps, null

    )(Create)
);
